import { useUser } from '@/hooks';
import { ListItem, ListItemText, Typography } from '@mui/material';
import { format } from 'date-fns';

export function UrgentActionUpdate({ update }) {
  const { data: user } = useUser(update.username);

  return (
    <ListItem disablePadding>
      <ListItemText
        primary={
          <Typography variant="caption" color="textSecondary">
            {user
              ? `${user?.displayName} - ${format(
                  new Date(update.time),
                  'dd/MM/yyyy HH:mm',
                )}`
              : '-'}
          </Typography>
        }
        secondary={
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {update.message}
          </Typography>
        }
      />
    </ListItem>
  );
}
